import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../ui';

/**
 * One dashboard panel: a titled section, and the `card` container its contents
 * measure themselves against. A card sits in a different width on every screen,
 * so what is inside lays itself out by `card-*:`, never by the viewport.
 */
const DashCard = ({ title, icon, action, className, children }) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        'tw-cq-card tw-flex tw-min-w-0 tw-flex-col tw-rounded-lg tw-border tw-border-solid tw-border-line',
        'tw-bg-surface-raised tw-p-4 tw-shadow-card page-sm:tw-px-5 page-sm:tw-py-[18px]',
        className,
      )}
    >
      <header className="tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-3 tw-gap-y-2">
        <h2 id={headingId} className="tw-m-0 tw-inline-flex tw-items-center tw-gap-2 tw-text-[0.9375rem] tw-font-medium tw-leading-snug tw-text-content">
          {icon}
          {title}
        </h2>
        {action}
      </header>
      {children}
    </section>
  );
};

/** The quiet "View all" beside a card's title. */
export const CardLink = ({ to, state, children }) => (
  <Link
    to={to}
    state={state}
    className="tw-rounded-[6px] tw-px-1.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-primary tw-no-underline tw-transition-colors hover:tw-bg-primary/10 hover:tw-text-primary tw-focus-ring"
  >
    {children}
  </Link>
);

/** What a card says when it has nothing to show. */
export const CardEmpty = ({ children }) => (
  <p className="tw-m-0 tw-flex tw-flex-1 tw-items-center tw-justify-center tw-px-2 tw-py-5 tw-text-center tw-text-[0.8125rem] tw-text-content-subtle">
    {children}
  </p>
);

export default DashCard;
